<template>
  <div id="app">
    <top-nav v-if="showNav" />
    <div class="app-main">
      <router-view />
    </div>
    <site-footer v-if="showFooter" />
  </div>
</template>

<script>
import TopNav from '@/components/TopNav.vue'
import SiteFooter from '@/components/SiteFooter.vue'

export default {
  name: 'App',
  components: { TopNav, SiteFooter },
  computed: {
    showNav() {
      return this.$route.name !== 'Login' && this.$route.name !== 'Register'
    },
    showFooter() {
      const path = this.$route.path
      return !path.startsWith('/admin') &&
        this.$route.name !== 'Login' &&
        this.$route.name !== 'Register'
    }
  }
}
</script>

<style>
html, body {
  height: 100%;
  margin: 0;
}
#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
.app-main {
  flex: 1;
}
</style>
